import { call, put, takeLatest, select } from 'redux-saga/effects';

import ApiRouts from '../../api/routes';
import { GET, POST } from "../../api";
import { FETCH_LIKE_COLLECTION, FETCH_PRODUCT_LIST, FETCH_SHOW_MORE_COLLECTION_LIST, FETCH_SHOW_MORE_PRODUCT_LIST, SET_LIKE_COLLECTION } from "../actions";
import { useLocation } from 'react-router-dom';


const getLikeCollectionId = (state) => state.likeCollectionId;


export function* FetchLikeCollectionSaga() {


    const likeCollectionId = yield select(getLikeCollectionId);


    try {


        const response = yield call(POST, `${ApiRouts.API_LIKE_Collection}/${likeCollectionId}`);

        if (response) {

            yield put({
                type: SET_LIKE_COLLECTION,
                payload: response.data.data
            });

            yield put({ type: FETCH_PRODUCT_LIST });
            yield put({ type: FETCH_SHOW_MORE_COLLECTION_LIST });


        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* likeCollectionSaga() {
    yield takeLatest(FETCH_LIKE_COLLECTION, FetchLikeCollectionSaga);
}

export default likeCollectionSaga;
